import { splitMessageByEmoji } from '@/utils/messageEmojiText'
import styles from '../UserChatBubble/index.module.scss'

export function UserMessageTextPlain({ text, textClassName, withEmoji }) {
  if (!withEmoji) return <p className={textClassName}>{text}</p>

  return (
    <p className={textClassName}>
      {splitMessageByEmoji(text).map((segment, index) =>
        segment.type === 'emoji' ? (
          <span key={`emoji-${index}`} className={styles.emojiInline}>
            {segment.value}
          </span>
        ) : (
          <span key={`text-${index}`}>{segment.value}</span>
        ),
      )}
    </p>
  )
}
